import * as React from 'react';
import { localize } from 'core/localization';
import { Tooltip } from 'components/common';
import { HINT_FOR_SPOT_COMMENT, HINT_FOR_GENERAL_COMMENT } from 'constants/review';
import { HintWrapper, HintContainer, HintButton, HintElementsContainer } from './Hint.styled';

type HintProps = {
  children: any;
  isExpanded: boolean;
  hintElements: any;
  hintName: string;
  position: any;
};

type HintState = {
  isExpanded: boolean;
}

export class Hint extends React.PureComponent<HintProps, HintState> {
  constructor(props: HintProps) {
    super(props);
    this.state = {
      isExpanded: this.props.isExpanded
    };
  }

  static defaultProps = {
    children: null,
    isExpanded: true,
    hintElements: null,
    hintName: ''
  };

  componentWillMount() {
    const { hintName } = this.props;
    if (hintName) {
      this.setState({
        isExpanded: !localStorage.getItem(hintName) || false
      });
    }
    this.showReviewHints(hintName);
  }

  componentDidUpdate(prevProps: HintProps) {
    const { isExpanded, hintName } = this.props;
    if (isExpanded !== prevProps.isExpanded) {
      this.setState({
        isExpanded
      });
    }
    this.hintShowOnce(hintName);
  }

  hintShowOnce = (hintName: any) => {
    if (hintName) {
      localStorage.setItem(hintName, true as any);
      this.setState({
        isExpanded: !localStorage.getItem(hintName)
      });
    }
  };

  showReviewHints = (hintName: any) => {
    if (hintName === HINT_FOR_GENERAL_COMMENT) {
      this.setState({
        isExpanded: false
      });
      if (
        localStorage.getItem(HINT_FOR_SPOT_COMMENT) &&
        !localStorage.getItem(HINT_FOR_GENERAL_COMMENT)
      ) {
        this.setState({
          isExpanded: true
        });
      }
    }
  };

  closePopover = (event: any) => {
    event.preventDefault();
    const { isExpanded } = this.state;
    const { hintName } = this.props;
    this.setState({
      isExpanded: !isExpanded
    });

    this.hintShowOnce(hintName);
  };

  render() {
    const { isExpanded } = this.state;
    const { hintElements, children, position } = this.props;
    return (
      <Tooltip
        trigger={'manual'}
        open={isExpanded}
        tooltipTheme={'light'}
        sticky={true}
        arrow={true}
        position={position}
        interactive
        html={
          <HintWrapper>
            <HintContainer>
              <HintElementsContainer>{hintElements}</HintElementsContainer>
              <HintButton onClick={this.closePopover}>{localize('[got it]')}</HintButton>
            </HintContainer>
          </HintWrapper>
        }
      >
        {children}
      </Tooltip>
    );
  }
}

export default Hint;
